import _slicedToArray from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
/**
 * @title multipleSelect hooks
 * @description multipleSelect by hold down shift key
 */
export default function useMultipleSelect(getKey) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    prevSelectedIndex = _useState2[0],
    setPrevSelectedIndex = _useState2[1];
  var multipleSelect = useCallback(function (currentSelectedIndex, data, selectedKeys) {
    var configPrevSelectedIndex = prevSelectedIndex !== null && prevSelectedIndex !== void 0 ? prevSelectedIndex : currentSelectedIndex;
    // add/delete the selected range
    var startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
    var endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
    var rangeKeys = data.slice(startIndex, endIndex + 1).map(function (item) {
      return getKey(item);
    });
    var shouldSelected = rangeKeys.some(function (rangeKey) {
      return !selectedKeys.has(rangeKey);
    });
    var changedKeys = [];
    rangeKeys.forEach(function (item) {
      if (shouldSelected) {
        if (!selectedKeys.has(item)) {
          changedKeys.push(item);
        }
        selectedKeys.add(item);
      } else {
        selectedKeys.delete(item);
        changedKeys.push(item);
      }
    });
    setPrevSelectedIndex(shouldSelected ? endIndex : null);
    return changedKeys;
  }, [prevSelectedIndex]);
  var updatePrevSelectedIndex = function updatePrevSelectedIndex(val) {
    setPrevSelectedIndex(val);
  };
  return [multipleSelect, updatePrevSelectedIndex];
}